export default {"src":"/_next/static/media/menu_filled.66463942.svg","height":24,"width":24};